import Vue from 'vue'
import {clearCookie} from "../../assets/js/common";
import md5 from "md5";

//state
const state = {
    userInfo: {}, // 用户信息
    menuList: [],
    unReadCount: 0
};

// getters
const getters = {}

// actions
const actions = {
    // 获取个人信息
    getUserInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.post("/ajax/person/center/user/detail").then(res => {
                commit('setUserInfo', res.data.data)
                resolve(res.data.data);
                //获取用户未读数量 2021-08-11
                commit('setUnReadCount')
            }).catch(e => {
                reject();
            })
        })
    },
    clearUserInfo({commit, state}) {
        localStorage.removeItem('token')
        localStorage.removeItem('tokenTime')
        localStorage.removeItem('expiresIn')
        localStorage.removeItem('sandboxToken')
        commit('setUserInfo', {})
        clearCookie(md5('_' + Vue.prototype.$config.env))
        clearCookie(md5('_' + Vue.prototype.$config.sandboxEnv))
    },
};

// mutations
const mutations = {// 设置用户
    setUserInfo(state, userInfo) {
        if (userInfo.sex === 0) {
            userInfo.sex = ''
        }
        if (userInfo.education === 0) {
            userInfo.education = ''
        }
        if (userInfo.marriage === 0) {
            userInfo.marriage = ''
        }
        if (userInfo.industry_id === 0) {
            userInfo.industry_id = ''
        }
        state.userInfo = userInfo
    },
    setMenuList(state, menuList) {
        state.menuList = menuList instanceof Array ? menuList : [];
    },
    // 获取未读数量
    setUnReadCount(state) {
        Vue.prototype.$axios.post("/ajax/message/unread/count", {}).then(res => {
            state.unReadCount = res.data.data;
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js